import { type FC, useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import Selector from 'modules/core/components/Selector'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import useAddRoleLegalEntities from 'modules/job_catalog/hooks/useAddRoleLegalEntities'

interface Props {
  roleId: string
  unasignedLegalEntities: LegalEntity[]
  onClose: () => void
}

const AddRoleLegalEntitiesModal: FC<Props> = ({ roleId, unasignedLegalEntities, onClose }) => {
  const addRoleLegalEntities = useAddRoleLegalEntities()
  const [selectedIds, setSelectedIds] = useState<string[]>([])

  const handleSubmit = async () => {
    const result = await addRoleLegalEntities(roleId, selectedIds)
    const { success } = handleResult(result, () => undefined)

    track(trackingEvents.jobCatalog.addLegalEntitySubmit, {
      event_category: 'Organizations',
      node_id: roleId,
    })

    if (success) {
      onClose()
    }
  }

  const handleClose = () => {
    onClose()
  }

  const options = unasignedLegalEntities.map((x) => {
    const { id, legal_name } = x.attributes

    return (
      <Selector.Option key={id} value={id} label={legal_name} searchValue={legal_name}>
        {legal_name}
      </Selector.Option>
    )
  })

  return (
    <Modal
      illustration="multiple-buildings"
      title={i18n.t('job_catalog.add_legal_entities_modal_title')}
      description={i18n.t('job_catalog.add_legal_entities_modal_description')}
      footer={
        <Button disabled={!selectedIds.length} submit>
          {i18n.t('common.submit')}
        </Button>
      }
      onSubmit={handleSubmit}
      onClose={handleClose}
    >
      <Selector.Container
        value={selectedIds}
        blankLabel={i18n.t('common.empty')}
        onChange={(ids) => setSelectedIds(ids as string[])}
        searchPlaceholder={i18n.t('common.search')}
        headerLabel={i18n.t('common.name')}
        isMultiSelect
      >
        {options}
      </Selector.Container>
    </Modal>
  )
}

export default observer(AddRoleLegalEntitiesModal)
